import Img from '@admin/components/html/img'
import PropTypes from 'prop-types'
import React from 'react'

class Article extends React.Component {

  static propTypes = {
    active: PropTypes.bool,
    image_url: PropTypes.string,
    service_icon: PropTypes.string,
    service_name: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string
  }

  static defaultProps = {
    active: true
  }

  linkRef = React.createRef()

  _handleClick = this._handleClick.bind(this)

  render() {
    const { image_url, title, text, service_name, url } = this.props
    return (
      <div { ...this._getLink() }>
        { image_url &&
          <div className="maha-link-article-image">
            <Img src={ image_url } />
          </div>
        }
        <div className="maha-link-details">
          <div className="maha-link-service">
            { service_name }
          </div>
          <div className="maha-link-title">
            { title }
          </div>
          <div className="maha-link-text">
            { text }
          </div>
        </div>
        <a href={ url } rel="noopener noreferrer" target="_blank" ref={ this.linkRef } />
      </div>
    )
  }

  _getLink() {
    const { active } = this.props
    return {
      className: active ? 'maha-link-article active' : 'maha-link-article',
      onClick: this._handleClick
    }
  }

  _handleClick() {
    const { active } = this.props
    if(!active) return
    this.linkRef.current.click()
  }

}

export default Article
